import { Grid, styled, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FieldModel } from "../../../Api/Models/FieldModel";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDInput from "../../../Components/MDInput";
import MDTypography from "../../../Components/MDTypography";
import { allParamsAction, selectedParamsAction } from "../../../Context/redux/actions";
import FieldDto from "../../../Types/Api/DTO/FieldDto";
import ApiResponse from "../../../Types/Api/Response";
import { ErrorToaast } from "../../../utils/toast/Toast";
import { isSubstring } from "../../../utils/tools/substring";
import AddChip from "../components/Chips/AddChip";
import DeleteChip from "../components/Chips/DeleteChip";
const CustomDivider = styled("div")(({ theme }) => ({
  border: `1px grey solid`,
}));

export default function FirstStep(props: { disabled: boolean; status: boolean; handleBack: any; handleNext: any; setLoading: any }) {
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  let allParams: FieldDto[] = useSelector((state: any) => state.allParams);
  let selectedParams: FieldDto[] = useSelector((state: any) => state.selectedParams);
  let fieldMode = new FieldModel();
  useEffect(() => {
    props.setLoading(true);
    fieldMode
      .getAll()
      .then(async (r) => {
        var response: ApiResponse<FieldDto[]> = r.data;
        dispatch(allParamsAction(response.data));
        // await setLoading(false);
        props.setLoading(false);
      })
      .catch((e) => {
        props.setLoading(false);
        ErrorToaast("مشکل در برقراری ارتباط");
      });

    return () => {
      dispatch(allParamsAction([]));
    };
  }, []);
  function filterdParams(searchText?: string) {
    if (searchText) {
      return allParams.filter((e) => isSubstring(e.name, searchText));
    }
    return allParams;
  }
  const handleAddToSelected = (model: FieldDto) => {
    if (selectedParams.filter((p) => p.id === model.id).length === 0) {
      dispatch(selectedParamsAction([model, ...selectedParams]));
    }
  };
  const handleDeleteFromSelected = (model: FieldDto) => {
    let sajad = selectedParams.filter((p) => p.id !== model.id);
    dispatch(selectedParamsAction(sajad));
  };
  return (
    <MDBox px={2}>
      <Grid container direction={"column"}>
        <Grid container item direction={"column"}>
          <Grid item>
            <MDBox py={2}>
              <MDTypography fontSize={14}>پارامتر های انتخاب شده</MDTypography>
            </MDBox>
            <CustomDivider />ِ
            <MDBox bgColor={"ghostwhite"} py={1} px={1} my={2} borderRadius={5}>
              {selectedParams.length > 0 &&
                selectedParams.map((e: FieldDto) => {
                  return <DeleteChip key={e.id} label={e.name} onDelete={handleDeleteFromSelected} model={e} />;
                })}
              {selectedParams.length < 1 && (
                <Grid container justifyContent={"center"}>
                  <MDTypography fontSize={14}>پارامتری انتخاب نشده است</MDTypography>
                </Grid>
              )}
            </MDBox>
          </Grid>
        </Grid>
        <Grid container item direction={"column"}>
          <Grid item container flexDirection={"column"}>
            <Grid item>
              <MDBox py={1}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                  <Grid item>
                    <MDTypography fontSize={14}>پارامتر های موجود</MDTypography>
                  </Grid>
                  <Grid container item wrap="nowrap">
                    <MDTypography>s</MDTypography>
                    <MDInput size={"small"} name="BankName" label="جستجو" onChange={(e: any) => setSearchText(e.target.value)} autoComplete="off" />
                  </Grid>
                </Grid>
              </MDBox>
              <CustomDivider />
            </Grid>

            <Grid item>
              <MDBox bgColor={"ghostwhite"} py={1} px={1} my={2} borderRadius={5}>
                <Grid container>
                  {filterdParams(searchText)?.map((e: FieldDto) => {
                    return (
                      <Grid item key={e.id}>
                        <AddChip
                          model={e}
                          onDelete={handleAddToSelected}
                          label={e.name}
                          active={selectedParams.filter((p) => p.id === e.id).length > 0}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <MDBox sx={{ display: "flex", flexDirection: "row", py: 2 }}>
        <MDButton color="primary" variant={"outlined"} disabled={props.disabled} onClick={props.handleBack} sx={{ mr: 1 }}>
          مرحله قبل
        </MDButton>
        <MDBox sx={{ flex: "1 1 auto" }} />

        <MDButton onClick={props.handleNext} variant={"outlined"} color="info">
          {props.status ? "اتمام" : "مرحله بعد"}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
